import { Component } from '@angular/core';
import { ProjectScenarioRetailDataGridService } from './project-scenario-retail-data-grid.service';
import { ActionButtonComponent } from 'libs/ui/src/lib/action-button/action-button.component';
import { ActivatedRoute, Router } from '@angular/router';
import {
  ProjectsFacade,
  SharedFacade,
  customDecode,
  customEncode,
  decrypt,
  encrypt,
} from '@piqet-angular/data';
import { ColDef } from 'ag-grid-community';
import {
  AccessPermissionService,
  CustomModalService,
  StorageTypeEnum,
} from '@piqet-angular/shared';
import { GridIconComponent } from 'libs/ui/src/lib/grid-icon/grid-icon.component';
import { ProjectsService } from 'libs/data/src/lib/services/projects/projects.service';
import { SharedService } from 'libs/data/src/lib/services/shared/shared.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ViewportScroller } from '@angular/common';
import { catchError, of, finalize, Subscription } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
@Component({
  selector: 'piqet-angular-project-scenario-retail',
  templateUrl: './project-scenario-retail.component.html',
  styleUrls: ['./project-scenario-retail.component.scss'],
})
export class ProjectScenarioRetailComponent {
  StorageTypeEnum = StorageTypeEnum;
  columnDefs!: ColDef[];
  checkboxValue = false;
  projectScenarioRetailPayload: any;
  activatedRoute: any;
  activatedRouteProjectId: any;
  frameworkComponents = {
    actionRenderer: ActionButtonComponent,
    iconsOfTransport: GridIconComponent,
  };
  searchData: any = '';
  sortColumnState: any;
  someSubscription: any;
  gridName: string = 'Project scenario retail list';
  event: any;
  scenarioId: any;
  isScreenDisabled: any;
  navigationConfig: any;
  headerData = {
    materialName: 'Retail',
  };
  nextRoute: any;
  menuDataForRouting: any;
  packageScenarioId: any;
  eId: any;
  isHideSideBar = false;
  retailList: any;
  deleteRetailItem: Subscription;
  editRetailSuccess!: Subscription;
  subscriptionInline!: Subscription;
  backRouteType: any;
  showEdit: boolean = false;
  constructor(
    private projectScenarioRetailDataGridService: ProjectScenarioRetailDataGridService,
    private projectService: ProjectsService,
    private viewportScroller: ViewportScroller,
    public sharedFacade: SharedFacade,
    public projectFacade: ProjectsFacade,
    public route: ActivatedRoute,
    private router: Router,
    private sharedService: SharedService,
    private spinnerService: NgxSpinnerService,
    private modal: CustomModalService,
    private toaster: ToastrService,
    private accessService: AccessPermissionService
  ) {
    this.activatedRoute = this.route.snapshot.routeConfig?.path;
    const url = location.href.split('/');
    this.activatedRouteProjectId = Number(atob(decodeURIComponent(customDecode(url[6]))));
    this.route.queryParams.subscribe((values: any) => {
      let value: any = decrypt(values.param ? values.param : '');
      value = value && !value.includes('undefined') ? JSON.parse(value) : '';
      this.scenarioId = value['id'];
      this.packageScenarioId = value['packageScenarioId'];
      this.eId = value['eId'];
      this.getRetailList();
    });

    this.sharedService.menuData$.subscribe((res: any) => {
      this.menuDataForRouting = res;
    });
    this.columnDefs = this.projectScenarioRetailDataGridService.projectScenarioRetailData();
    this.projectScenarioRetailPayload = this.projectScenarioRetailDataGridService.getPayload(
      this.searchData
    );

    this.deleteRetailItem = this.projectScenarioRetailDataGridService.deleteRetailData$.subscribe(
      async deleteData => {
        this.deleteRetailData(deleteData[0]);
      }
    );

    this.editRetailSuccess =
      this.projectScenarioRetailDataGridService.editRetailSuccessData$.subscribe(
        async deleteData => {
          this.getRetailList();
        }
      );
  }

  ngOnInit(): void {
    this.viewportScroller.scrollToPosition([0, 0]);
    this.showEdit = this.accessService.hasPermission('edit', this.activatedRoute, 'packaging');
    this.subscriptionInline =
      this.projectScenarioRetailDataGridService.inlineEditingObservable$.subscribe(
        (inlineData: any) => {
          this.inlineDataEditing(inlineData);
        }
      );
  }

  inlineDataEditing(payload: any) {
    this.projectService
      .projectRetailAndConsumerInlineEdit(payload)
      .pipe(
        catchError((error: any) =>
          of(this.toaster.error('An error occurred. Please try again later.'))
        ),
        finalize(() => {
          this.getRetailList();
        })
      )
      .subscribe(res => {
        res.messageType ? this.toaster.error(res.message) : this.toaster.success(res.message);
      });
  }

  onCheckboxChange(eve: any) {
    this.checkboxValue = eve.target.checked ? true : false;
    this.projectService.disableRetail(this.checkboxValue, this.scenarioId).subscribe();
  }

  async getRetailList() {
    const retailList = (
      await this.projectService.getMyAllProjectScenarioRetailListAsync(
        this.StorageTypeEnum.Retail,
        this.scenarioId,
        this.activatedRouteProjectId
      )
    ).data;
    retailList?.retailList.map((item: any) => {
      item.storageTransportDetail.map((data: any) => {
        data['cityName'] = data.originName;
      });
    });
    this.retailList = retailList;
    this.checkboxValue = this.retailList?.isExcludeRetail;
    this.isScreenDisabled = this.retailList?.isLockProject;
    this.navigationConfig = {
      scenarioId: this.scenarioId,
      packageScenarioId: this.packageScenarioId,
      eId: this.eId,
      activatedRouteProjectId: this.activatedRouteProjectId,
      activatedRoute: this.activatedRoute,
      isProjectLocked: this.isScreenDisabled,
      isProductPage: true,
    };
  }

  async addCustomRetail(scenarioId: any, id: any, storageTypeId: any, label?: any) {
    let response = await this.projectService.getAddEditPackRetailModalAsync(
      scenarioId,
      id,
      storageTypeId
    );
    this.modal.invoke('newAddProjectScenarioRetail', {
      initialState: {
        newMyProjectsPackRetail: response.data,
        label: label,
        pathName: this.activatedRoute,
        addTransportScenarioColDef:
          this.projectScenarioRetailDataGridService.getTransportModalForManualLocationDataColumn(),
        distanceProcessColumnDef:
          this.projectScenarioRetailDataGridService.getTransportModalForManualDestinationDataColumn(),
        customTransportColumnDef:
          this.projectScenarioRetailDataGridService.getCustomTransportItemsList(),
        customEolDef: this.projectScenarioRetailDataGridService.getendOfLifeDataColumn(),
      },
      class: 'modal-xl',
    });
    this.modal.ref?.content.saveNewMyProjectPackRetailEvent.subscribe(
      (saveNewMyProjectPackRetailEvent: any) => {
        this.addRetailData(saveNewMyProjectPackRetailEvent);
      }
    );
  }

  addRetailData(data: any) {
    this.projectService
      .addEditMyAllProjectPackRetailData(data)
      .pipe(
        catchError((error: any) =>
          of(this.toaster.error('An error occurred. Please try again later.'))
        ),
        finalize(() => {
          this.modal.close();
          this.getRetailList();
        })
      )
      .subscribe(res => {
        res.messageType ? this.toaster.error(res.message) : this.toaster.success(res.message);
      });
  }

  deleteRetailData(data: any) {
    this.projectService
      .deleteProjectPackRetailList(data.id)
      .pipe(
        catchError((error: any) =>
          of(this.toaster.error('An error occurred. Please try again later.'))
        ),
        finalize(() => {
          this.getRetailList();
        })
      )
      .subscribe(res => {
        res.messageType ? this.toaster.error(res.message) : this.toaster.success(res.message);
      });
  }

  ngOnDestroy() {
    this.deleteRetailItem.unsubscribe();
    this.editRetailSuccess.unsubscribe();
  }
}
